// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"42514a5f","667":"9203f467"}[chunkId] + ".chunk.js";
};